import React, { useEffect } from "react";
import { Row, Col, Placeholder } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { MdError } from "react-icons/md";
import { CiTimer } from "react-icons/ci";
import Pie from "./Pie";
import { dashboardActions } from "../../actions/dashboard.actions";
import TimeDisplay from "./TimeDisplay";
import CollapsibleCard from "../common/CollapsibleCard";

function KPIs(props) {
  const dispatch = useDispatch();
  const dashboardReducer = useSelector((state) => state.dashboard);

  useEffect(() => {
    let queryParams = {
      clientId: props.user.clientId,
      clientGuid: props.user.clientGuid,
      pageSize: 10,
      pageNumber: 1,
    };

    dispatch(dashboardActions.get(queryParams));

    // eslint-disable-next-line
  }, [location]);



  return (
    <>
      <Row className="mb-3">
        <Col>
          <div data-tour="kpis">
            <CollapsibleCard
              title="Average Execution Time Last Month"
              icon={<CiTimer className="mb-1" />}
              defaultExpanded={true}
              className="h-100"
            >
            <div className="text-center">
              {!dashboardReducer.loadingKpis && (
                <div className="fs-6 fw-bold text-primary">
                  <TimeDisplay
                    time={dashboardReducer.kpisResult?.avgExecutionTime}
                  />
                </div>
              )}
              {dashboardReducer.loadingKpis && (
                <Placeholder
                  as={"div"}
                  animation="glow"
                >
                  <Placeholder xs={12} size="lg" style={{ height: "50px" }} />
                </Placeholder>
              )}
            </div>
          </CollapsibleCard>
          </div>
        </Col>
      </Row>
    </>
  );
}

export default KPIs;
